import { HashRouter, Route, Switch } from "react-router-dom";
import Main from "./pages/main";
import Result from "./pages/result";

// Redux
import { Provider } from "react-redux";
import store from "./redux/store";
import Page from "./pages/page";

const App = () => {
  return (
    <Provider store={store}>
      <HashRouter>
        <Page>
            <Switch>
            <Route exact path="/" component={Main} />
            <Route exact path="/result/:id" component={Result} />
          </Switch>
        </Page>
      </HashRouter>
    </Provider>
  );
};

export default App;
